export default "__VITE_ASSET__DRhds1SF__"